import { registerWidget, IWidgetSettings, IWidget, IWidgetDefinition, SubFilter, IBaseSettings } from '../../common/core';

var template = require("./subfilters.html");
var styles = require("./subfilters.scss").toString();

export interface ISubFiltersSettings extends IBaseSettings {
    /**
     * Format label
     */
    "formatLabel"?: (filter: SubFilter) => string;

    /**
     * Show all filters
     * true if not set
     */
    "showFilters"?: false;
}

/**
* Settings for subfilters widget
*/
export interface ISubFiltersWidgetSettings extends IWidgetSettings<ISubFiltersSettings, null> {
    type: "subfilters"
}

export class SubFiltersData {
    filters: SubFilter[];
    hasActiveFilters: boolean;
    constructor(public widget: IWidget<SubFiltersData, ISubFiltersSettings, null>) { }

    clearFilter(filter) {
        if (filter.disabled) {
            return;
        }
        var w = this.widget.service.getWidgetById(filter.widgetId);
        w.component.runAction('removeSubFilter', filter);
        this.widget.service.setState();
        /*
        if (w.definition && w.definition.removeSubFilter) {
            w.definition.removeSubFilter(w.component, filter);
            
        }
        */
    }

    clearFilters() {
        var self = this;
        self.widget.data.filters.forEach((f) => {
            var w = self.widget.service.getWidgetById(f.widgetId);
            // w.component.runAction('removeSubFilter', f);
            if (w.definition && w.definition.removeSubFilter) {
                w.definition.removeSubFilter(w.component, f);
            }
        });
        this.widget.service.setState();
    }

    formatLabel(filter: SubFilter) {
        if (this.widget.settings.formatLabel) {
            return this.widget.settings.formatLabel(filter);
        }
        if (filter.widgetLabel) {
            return `${filter.widgetLabel}: ${filter.label}`;
        }
        return filter.label;
    }

    getFilters() {
        var filters = [];
        this.widget.service.getAllWidgets().forEach(function (w) {
            var widgetFilters = w.runAction('getSubFilters');
            if (widgetFilters) {
                widgetFilters.forEach(function (filter) {
                    filters.push(filter);
                });
            }
            /*
            if (w.definition && w.definition.getSubFilters) {
                var widgetFilters = w.definition.getSubFilters(w);
                if (widgetFilters) {
                    widgetFilters.forEach(function (filter) {
                        filters.push(filter);
                    });
                }
            }
            */
        });
        return filters;
    }

    beforeSearch() {
        this.filters = this.getFilters();
        this.hasActiveFilters = !!this.filters.filter(x => !x.disabled).length;
    }
}

export const SubFiltersWidgetDefinition: IWidgetDefinition<SubFiltersData, ISubFiltersSettings, null> = {
    init(widget) {
        widget.data = new SubFiltersData(widget);
    },
    beforeSearch(widget) {
        widget.data.beforeSearch();
    },
    template: template,
    styles: styles
};

registerWidget('subfilters', SubFiltersWidgetDefinition);
